<template>
  <div id="page-content">
    <div
      v-if="title || ( breadcrumbItems && breadcrumbItems.length )"
      id="header"
      :class="{ 'page-header--compact py-1!': compactHeader }"
    >
      <div>
        <div v-if="breadcrumbItems?.length" class="breadcrumbs text-sm md:text-base">
          <ul>
            <li v-for="( item, idx ) in breadcrumbItems" :key="idx">
              <router-link
                v-if="item.to && idx !== breadcrumbItems.length - 1"
                :to="item.to"
                class="link link-hover link-primary no-underline opacity-90"
              >{{ item.label }}</router-link>
              <span
                v-else-if="idx === breadcrumbItems.length - 1"
                class="font-semibold text-primary"
              >{{ item.label }}</span>
              <span v-else class="opacity-80">{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div
          v-if="title"
          class="flex items-center justify-between"
          :class="{ 'mt-2': breadcrumbItems?.length }"
        >
          <h1
            class="font-bold mb-0"
            :class="compactHeader ? 'text-xl' : 'text-2xl'"
          >{{ title }}</h1>
          <slot name="action"></slot>
        </div>
        <div
          v-else-if="$slots.action"
          class="mt-2 flex justify-end"
        >
          <slot name="action"></slot>
        </div>
        <div class="border-t pt-3 mt-3 empty:hidden">
          <slot name="subtitle"></slot>
        </div>
      </div>
    </div>
    <div
      class="page-content empty:hidden"
      :class="{ card: contentCard }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

import type { AppBreadcrumbItem } from "@tmi/types/context/search-context";

export type PageBreadcrumbItem = AppBreadcrumbItem;

defineProps( {
  title: {
    type: String,
    default: undefined
  },
  breadcrumbItems: {
    type: Array as PropType<AppBreadcrumbItem[]>,
    default: undefined
  },
  compactHeader: {
    type: Boolean,
    default: false
  },
  contentCard: {
    type: Boolean,
    default: true
  },
  maxWidth: {
    type: String,
    default: '',
    validator: ( value: string ) => [ '', 'sm', 'md', 'lg', 'xl' ].indexOf( value ) !== -1
  }
} );
</script>

<style>
#page-content .page-content:has(.card:empty) {
  display: none;
}

.product #header { display: none; }

</style>
